<script>
	import BaseLayout, {$$render} from '../Layout.vue'
	
	export default {
		name: 'row',
		
		mixins: [BaseLayout],
		
		props: {
			dir: {
				type: String,
				default: 'vert'
			}
		},
		
		render(c){
			return $$render.call(this, c)
		}
	}
</script>

<style>
</style>
